<template>
  <div>
    <Suspense>
      <!-- fallback while specialties are loading -->
      <template #fallback>
        <div class="py-12 text-center text-gray-500">加载中专科列表…</div>
      </template>

      <!-- once loaded, show the listing -->
      <template #default>
        <MedicalSpecialtyListing :specialty_data="specialties" />
      </template>
    </Suspense>
  </div>
</template>

<script setup>

const { setSEOMeta, setOrganizationStructuredData, setLLMOptimizedMeta } = useSEO()

// no top-level await, no manual ref
const { data: specialties, error } = useAsyncData(
  'specialties',
  () => $fetch('/api/specialty/getSpecialties'),
  { default: () => [] }
)

if (error.value) {
  console.error('[Specialty Index] AsyncData error:', error.value)
  throw createError({
    statusCode: 500,
    statusMessage: '专科信息加载失败'
  })
}

// SEO metadata (unchanged)
setSEOMeta({
  title: '专科医生列表和对应常见病症',
  description: '查看专科医生列表和对应常见病症，找到最适合您的专科医生。北美好医生为您提供全面的专科医疗信息，协助您在美国便利就医。',
  keywords: [
    '专科医生',
    '医生列表',
    '常见病症',
    '医疗专科',
    '华人医疗',
    '北美医生',
    '专科查询'
  ],
  ogImage: '/HYS-logo-icon-06.png',
  locale: 'zh-Hans'
})

setLLMOptimizedMeta({
  contentType: 'service-page',
  primaryTopic: '医疗专科列表',
  keyTerms: [
    '专科医生',
    '医疗专科',
    '常见病症',
    '华人医疗服务',
    '医生查询'
  ],
  contentSummary: '完整的医疗专科列表，包括各专科常见病症和对应医生信息，帮助患者找到合适的专科医生',
  targetAudience: '需要专科医疗服务的华人患者'
})
</script>
